import { EMAIL_TYPE, PAYMENT_METHOD_BRAND, PAYMENT_METHOD_TYPE, USER_TYPE } from 'helpers'
import { Region } from 'ducks/admin/types'
import { Address, Territory } from 'ducks/types'
import { UserInfoType } from 'api/auth'
import { ChangeUserEmail, CreateUserRequest } from 'api/punchlist/users/types'

/** TYPES **/
export const userTypes = {
  FETCH_CURRENT_USER: 'FETCH_CURRENT_USER',
  CREATE_USER: 'CREATE_USER',
  UPDATE_USER: 'UPDATE_USER',
  SET_VALUE: 'SET_USER_VALUE',
  SET_VALUES: 'SET_USER_VALUES',
  UPDATE_USER_LIST: 'UPDATE_USER_LIST',
  FETCH_USER_HEAD: 'FETCH_USER_HEAD',
  GET_USER_INFO: 'GET_USER_INFO',
  SEND_VERIFICATION_EMAIL: 'SEND_VERIFICATION_EMAIL',
  CHANGE_USER_EMAIL: 'CHANGE_USER_EMAIL',
  RESET_PASSWORD_REQUEST: 'RESET_PASSWORD_REQUEST',
  NEW_CREATE_USER: 'NEW_CREATE_USER',
  SEND_SET_PASSWORD_EMAIL: 'SEND_SET_PASSWORD_EMAIL'
}

/** ACTIONS **/
export interface FetchCurrentUserAction {
  type: typeof userTypes.FETCH_CURRENT_USER
  payload: null
  callback: (succ: boolean) => void
}

export interface SendVerificationEmailAction {
  type: typeof userTypes.SEND_VERIFICATION_EMAIL
  payload: {
    userEmail: string,
    auth0AppId: string
  }
  callback: (succ: boolean) => void
}

export interface ChangeUserEmailAction {
  type: typeof userTypes.CHANGE_USER_EMAIL
  payload: ChangeUserEmail
  callback: (succ: boolean, errorCode?: string) => void
}

export interface SendSetPasswordEmailAction {
  type: typeof userTypes.SEND_SET_PASSWORD_EMAIL
  payload: {
    userEmail: string,
    auth0Id: string
  }
  callback: (succ: boolean) => void
}
export interface CreateUserAction {
  type: typeof userTypes.CREATE_USER
  payload: any
  callback: (succ: boolean) => void
}

export interface UpdateUserAction {
  type: typeof userTypes.UPDATE_USER
  payload: Partial<UserType>
  callback: (succ: boolean) => void
}

export interface UpdateUserListPayload {
  attr: keyof UserType
  opp?: 'add' | 'removeAll' | 'replace'
  list?: any[]
  showError?: boolean
}

export interface UpdateUserListAction {
  type: typeof userTypes.UPDATE_USER_LIST
  payload: UpdateUserListPayload
  callback: (succ: boolean) => void
}

export interface FetchUserHeadAction {
  type: typeof userTypes.FETCH_USER_HEAD
  payload: FetchUserHeadParams
  callback?: (succ: boolean) => void
}

export interface FetchUserHeadParams {
  email: string,
  userType: string
}

export interface UserValue {
  attr: keyof UserType
  value: any
}

export interface UserSetValueAction {
  type: typeof userTypes.SET_VALUE
  payload: UserValue
}

export interface UserValues {
  attrs: Partial<UserType>
}

export interface UserSetValuesAction {
  type: typeof userTypes.SET_VALUES
  payload: UserValues
}

export interface GetUserInfoAction {
  type: typeof userTypes.GET_USER_INFO
  payload: null
  callback: (succ: boolean, userInfo?: UserInfoType) => void
}

export interface ResetPasswordRequestAction {
  type: typeof userTypes.RESET_PASSWORD_REQUEST
  payload: ResetPasswordPayload
  callback: (succ: boolean) => void
}

export interface NewCreateUserAction {
  type: typeof userTypes.NEW_CREATE_USER
  payload: CreateUserRequest
  callback: (succ: boolean) => void
}

export type UserActions =
  | FetchCurrentUserAction
  | CreateUserAction
  | UpdateUserAction
  | UpdateUserListAction
  | UserSetValueAction
  | UserSetValuesAction
  | FetchUserHeadAction
  | GetUserInfoAction
  | SendVerificationEmailAction
  | ChangeUserEmailAction
  | ResetPasswordRequestAction
  | NewCreateUserAction
  | SendSetPasswordEmailAction
/** REDUCER **/
export interface Email {
  emailType: EMAIL_TYPE
  email: string
}

export interface ResetPasswordPayload {
  params: { userId: string, password: string }
  callback: (success: boolean) => void
}

export interface PaymentMethod {
  type: PAYMENT_METHOD_TYPE,
  brand: PAYMENT_METHOD_BRAND,
  expirationMonth: number,
  expirationYear: number,
  last4: number,
  stripeId: string,
  id?: string,
  createdOn: number,
  isDefault: boolean
}

export interface UserType {
  id: string
  email: Email[]
  emailString?: string
auth0Id?: string
  firstName: string
  middleName: string
  lastName: string
  phone: number | null
  tosAccepted: boolean
  nar: boolean | null
  narId: string | null
  affiliate: string | null
  companyName: string
  address: Address
  picture: string
  protectPlanIsNew?: boolean | null

  registrationComplete: boolean
  type: string
  clientType: USER_TYPE
  paymentMethods: PaymentMethod[]
  customerId: string

  userProperties: Partial<UserReferrals>
  region?: Region

  territory?: Territory
  onProtectPlanNotificationList?: boolean
  institutionalRole?: string | null
  oneClickApproval?: boolean

}


export interface UserReferrals {
  source?: string
  campaign?: string
  content?: string
  medium?: string
}
